/**
 * Data structure for a Game ID
 */
(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
    } else{
        root.GidDecoder=factory();
    }
})(function () {
    var PK = 'pk';
    var GID= 'gid';
    var _ = '_';
    var SLASH = '/';
    var DASH = '-';
    var TEN = 10;

    var r_pk = /^(?:pk_)?(\d{3,})$/;
    var r_gid = /^(?:gid_)?((\d{4})[_/](\d{2})[_/](\d{2})[_/](([a-z\d]{0,3})([a-z]{3}))[_-](([a-z\d]{0,3})([a-z]{3}))[_-](\d))$/;

    var cache = {};

    function parse (id) {
        var match = id.match(r_pk) || id.match(r_gid);
        if(match){
            return cache[id] = match.length === 12 ? parseGID(match) : parseGPK(match[1]);
        }
        return null;
    }
    function parseGPK (id) {
        return {
            format: PK,
            pk: id,
            storeVal: PK + _ + id,
            displayVal: id
        }
    }

    function parseGID (parts) {
        var key = parts[1];
        var year = parts[2];
        var month = parts[3];
        var day = parts[4];
        var game_number = parts[11];
        var away_full_code = parts[5];
        var home_full_code = parts[8];
        var gid = year + _ + month + _ + day + _ + away_full_code + _ + home_full_code + _ + game_number;
        var month_day = month + SLASH + day + SLASH;
        var gameDateString = month_day + year;
        var gid_path = GID + _ + gid;
        var date_format = year + SLASH + month_day + away_full_code + DASH + home_full_code + DASH + game_number;
        return cache[key] = cache[gid] = cache[date_format] = cache[gid_path] = {
            format: GID,
            gid: gid,
            gid_path: gid_path,
            year: year,
            month: month,
            day: day,
            away_full_code: away_full_code,
            away_team_code: parts[6],
            away_sport_code: parts[7],
            home_full_code: home_full_code,
            home_team_code: parts[9],
            home_sport_code: parts[10],
            game_number: game_number,
            game_date: month_day + year,
            date_format: date_format,
            storeVal: gid_path,
            displayVal: gid,
            isValid: true
        }
    }
    
    return  function (gameid) {
        return cache[gameid] || parse(gameid + '');
    };  
});